import * as z from "zod/mini"

const emailSchema = z.email({ message: "Please enter a valid email address" })

export { emailSchema }
